<template>
	<AdminLayout>
		<p class="admin-center-subtitle mb-4">Portal Settings</p>

		<nav class="flex border-b border-neutral-subtle py-2">
			<ul role="list" class="flex flex-col md:flex-row min-w-full flex-none gap-x-8 px-2 text-lg font-semibold text-grayscale-body-light">
				<li v-for="(tab, index) in tabs" :key="tab.name">
					<span class="cursor-pointer" :class="currentTabIndex === index ? 'text-information' : 'hover:text-grayscale-body'" @click="tabSelected(index)">{{ tab.name }}</span>
				</li>
			</ul>
		</nav>

		<div class="mt-5"><GeneralSettings v-if="currentTabIndex === 0"/></div>
		<div class="mt-5"><SecuritySettings v-if="currentTabIndex === 1"/></div>
		<div class="mt-5"><AdvancedSettings v-if="currentTabIndex === 2"/></div>

		<div v-if="version || buildNumber" class="flex w-full">
			<span class="mx-auto text-sm">{{ version }} {{ buildNumber }}</span>
		</div>
	</AdminLayout>
</template>

<script setup lang="js">
import AdminLayout from "@/layouts/AdminLayout.vue";
import { onMounted, ref } from 'vue'
import GeneralSettings from '@/views/Admin/PortalSettings/GeneralSettings.vue'
import AdvancedSettings from '@/views/Admin/PortalSettings/AdvancedSettings.vue'
import SecuritySettings from '@/views/Admin/PortalSettings/SecuritySettings.vue'

const tabs = [
	{ name: 'General' },
	{ name: 'Security' },
	{ name: 'Advanced' },
]
const currentTabIndex = ref(0)
const version = ref(`${import.meta.env.VITE_APP_NAME} v${__APP_VERSION__}`)
const buildNumber = ref(null)

function tabSelected(tabIndex) {
	currentTabIndex.value = tabIndex
}

onMounted(() => {
	getBuildNumber()
})

/**
 * This function depends on the build->script section of .gitlab-ci.yml which will create a dist/version.json file
 * that contains the gitlab build number (in the CI_PIPELINE_IID variable).
 */
async function getBuildNumber() {
	try {
		const response = await fetch('/version.json')
		const data = await response.json()

		if (data.version) {
			buildNumber.value = `(build ${data.version})`
		}
	} catch (e) {/**/}
}

</script>
